import diacriticHelper from 'diacritic-regex-helper';


const filterNames = (country, filter) => (
    country.nameLiteral.match(new RegExp(diacriticHelper(filter), 'gi'))
);


export default filterNames;
